<template>
  <div class="section-block">
    <div class="section-title mb-0 text-center" :class="isPhone ? 'merriweather-light-reg-20 px-4' : 'merriweather-reg-26'">{{ title }}</div>
    <div v-if="subtitle" class="section-subtitle merriweather-light-reg-40 text-center" :class="isPhone ? 'merriweather-reg-28 px-4' : 'merriweather-light-40'">
      <p class="mb-0">{{ subtitle }}</p>
    </div>
    <div class="text-center" :class="isPhone ? 'merriweather-light-18 px-4' : 'merriweather-light-24'" v-html="description"></div>
    <div class="weekends-grid pt-5">
      <div
        v-for="(weekend, index) in weekends"
        :key="weekend.id || index"
        class="mb-4 d-flex align-items-stretch"
      >
        <Cardweekendall :weekend="weekend" />
      </div>
    </div>
  </div>
</template>

<script>
import Cardweekendall from "../../components/cards/Cardweekendall.vue";
export default {
  name: "SectionBlock",
  props: {
    weekends: { type: Array, required: true },
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    description: { type: String, default: "" },
  },
  components: { Cardweekendall },
  data() {
    return {
      isPhone: window.innerWidth <= 768,
    };
  },
};
</script>

<style scoped lang="scss">
.weekends-grid {
  width: 100%;
  padding-left: 94px;
  padding-right: 46px;
  display: grid;
  grid-template-columns: repeat(2, 420px);
  grid-template-rows: 2fr;
  justify-content: center;
  grid-column-gap: 40px;
  grid-row-gap: 10px;

  @media screen and (max-width: 768px) {
    padding-left: 0;
    padding-right: 0;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }
}
</style>
